import * as React from 'react';
import sanitizeHtml from 'sanitize-html';

import ActionButton from 'components/buttons/action-button/ActionButton';
import VerticalSpacing from 'components/vertical-spacing/VerticalSpacing';

import { __t, applyTranslations } from 'utils/language';
import { allowSocialNetworks, triggerConsentPanel } from 'utils/consents';

import './content-placeholder-info.scss';

applyTranslations(require('./content-placeholder-info.i18n.json'));

const SANITIZE_HTML_CONFIG = {
  allowedTags: ['a', 'br']
};

function stopPropagation(event: React.MouseEvent): void {
  event.stopPropagation();
}

const ContentPlaceholderInfo = (): JSX.Element => {
  if (!window.UC_UI?.isInitialized()) {
    return (
      <div className="content-placeholder-info">
        <div
          className="content-placeholder-info__body"
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(__t('content_placeholder_info.uc_failed'), SANITIZE_HTML_CONFIG) }}
        />
      </div>
    );
  }

  return (
    <div
      className="content-placeholder-info"
      onClick={stopPropagation}
    >
      <div className="content-placeholder-info__title">
        {__t('content_placeholder_info.title')}
      </div>
      <VerticalSpacing type="small" />
      <div className="content-placeholder-info__subtitle">
        {__t('content_placeholder_info.subtitle')}
      </div>
      <VerticalSpacing type="small" />
      <div
        className="content-placeholder-info__body"
      >
        {__t('content_placeholder_info.body')}
        <a
          href="#"
          onClick={triggerConsentPanel}
        >
          {__t('content_placeholder_info.here_link')}
        </a>
      </div>
      <VerticalSpacing type="large" />
      <ActionButton
        color="primary"
        onClick={(event) => {
          allowSocialNetworks();
          event.stopPropagation();
        }}
      >
        {__t('content_placeholder_info.enable_cta')}
      </ActionButton>
    </div>
  );
};

export default ContentPlaceholderInfo;
